import { ProjectPropertyType } from 'src/constants/project';
import { ModelSnapshot } from 'src/containers/ProjectDiagram/types/model';
import {
  RDFS_DOMAIN_IRI,
  RDFS_RANGE_IRI,
  SCHEMA_ORG_DOMAIN_INCLUDES_IRI,
  SCHEMA_ORG_RANGE_INCLUDES_IRI,
} from 'src/templates/queries/iris';

export const getPropertyIrisForModelConcept = (
  projectPropertyType: ProjectPropertyType,
  model: ModelSnapshot,
  iri: string
) => {
  let domainIri: string;
  let rangeIri: string;
  if (
    projectPropertyType === ProjectPropertyType.RDFS ||
    (projectPropertyType === ProjectPropertyType.CUSTOM &&
      model.modelData.propertyTypesByIri[iri] === ProjectPropertyType.RDFS)
  ) {
    domainIri = RDFS_DOMAIN_IRI;
    rangeIri = RDFS_RANGE_IRI;
  } else {
    domainIri = SCHEMA_ORG_DOMAIN_INCLUDES_IRI;
    rangeIri = SCHEMA_ORG_RANGE_INCLUDES_IRI;
  }
  return { domainIri, rangeIri };
};
